import Header from "../Header";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";
import styles from "./myPartyDetail.module.scss";
import "../GuestMode/GuestMode.scss";

const MyPartyDetailSkeleton = () => {
  return (
    <>
      <Header />
      <div className="centerGroup" data-testid="my-party-detail-skeleton">
        <div className="desktopUI">
          <div className="row userProfile_Header">
            <Breadcrumbs />
            <div className="d-flex justify-content-end space col-6">
              <div className="loading-effect loading-effect-text loading-effect-text-xs" style={{ height: "32px" }} />
            </div>
          </div>
        </div>
      </div>

      <div className={styles.myPartyDetailPage}>
        <div className={styles.myPartyContainer}>
          <div className="loading-effect loading-effect-text loading-effect-text-sm mt-3" />

          <div className="text-white mt-2 w-100">
            <div className="loading-effect loading-effect-text loading-effect-text-sm mb-3" />
            <div className="d-flex justify-content-between align-items-center mt-3 gap-2">
              <div className="loading-effect flex-fill" style={{ height: "31px", borderRadius: "999px" }} />
              <div className="loading-effect flex-fill" style={{ height: "31px", borderRadius: "999px" }} />
              <div className="loading-effect flex-fill" style={{ height: "31px", borderRadius: "999px" }} />
            </div>
          </div>

          <div className={styles.clubImageContainer}>
            <div className={`${styles.clubImage} loading-effect loading-effect-image`} />
            <div className={`${styles.clubName} loading-effect loading-effect-title`} />
          </div>

          <div className={styles.setTitleCityBox}>
            <div className="loading-effect loading-effect-text loading-effect-text-sm" />
            <div className="loading-effect loading-effect-text loading-effect-text-xs" />
          </div>

          <div className={styles.buttonsContainer}>
            <div className={styles.firstSection}>
              <div className="loading-effect w-100" style={{ height: "44px", borderRadius: "0" }} />
              <div className="loading-effect w-100 mt-2" style={{ height: "44px", borderRadius: "0" }} />
              <div className={styles.warningContainer}>
                <div className="loading-effect loading-effect-text loading-effect-text-md mb-2" />
                <div className="loading-effect loading-effect-text loading-effect-text-md mb-2" />
                <div className="loading-effect loading-effect-text loading-effect-text-md mb-2" />
                <div className="loading-effect loading-effect-text loading-effect-text-sm" />
              </div>
            </div>
          </div>

          <div className={styles.offerSection}>
            <div className="loading-effect w-100" style={{ height: "120px", borderRadius: "0" }} />
          </div>

          <div className={styles.buttonsContainer}>
            <div className={styles.line} />
            <div className="d-flex justify-content-center">
              <div className="loading-effect loading-effect-text loading-effect-text-md" />
            </div>
            <div className={styles.secondSectionAccepted}>
              <div className="loading-effect flex-fill" style={{ height: "44px", borderRadius: "0" }} />
              <div className="loading-effect flex-fill" style={{ height: "44px", borderRadius: "0" }} />
            </div>

            <h3 className={styles.invitedFriendsTitle}>
              <span className="loading-effect loading-effect-text loading-effect-text-md" />
            </h3>

            <div className="d-flex flex-column gap-3 text-left w-100">
              {Array.from({ length: 2 }, (_, index) => (
                <div className="m-0 align-items-center col d-flex" key={`requested-club-skeleton-${index}`}>
                  <div className="loading-effect" style={{ height: "35px", width: "50px", marginLeft: "10px", marginRight: "10px" }} />
                  <div className="align-content-center col d-flex">
                    <div className="loading-effect loading-effect-text loading-effect-text-md" />
                  </div>
                </div>
              ))}
            </div>
          </div>

          <h3 className={styles.invitedFriendsTitle}>INVITED FRIENDS</h3>
          {Array.from({ length: 4 }, (_, index) => (
            <div className={styles.invitedFriendsContainer} key={`invited-friend-skeleton-${index}`}>
              <div className={styles.invitedFriendBox}>
                <div className={styles.avatarImg}>
                  <div className="loading-effect loading-effect-circle" style={{ width: "80px", height: "80px" }} />
                </div>
                <div className={styles.infoBox}>
                  <div className={styles.nameStatusBox}>
                    <div className="text-left">
                      <div className="loading-effect loading-effect-text loading-effect-text-sm mb-2" />
                      <div className="loading-effect loading-effect-text loading-effect-text-md" />
                    </div>
                    <div className="text-right">
                      <div className="loading-effect loading-effect-text loading-effect-text-xs" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default MyPartyDetailSkeleton;
